export default {
  dataTableItemsPerPageOptions: [5, 10, 15, 30, 50]
}
